<script>
  import { onMount } from 'svelte';
  import Confirm from '../components/confirm.svelte';
  import { deleteForm, getForm } from '../../services';
  import { goto } from '../../util';
  import { handleRedirect, pages } from '../../config';

  export let params;
  let form;
  let sid;

  $: fid = params?.fid;
  $: formName = form?.name || '';

  $: desc = `
  Are you sure you want to remove the form called: ${formName}?
  You will lose all of your submissions and powerups. This is irreversible
  but you may make a new form with the same name after this one is removed.
  `;

  onMount(async () => {
    form = await getForm({ fid });
    sid = form?.sid;
  });

  function onCancel() {
    if (!handleRedirect(params.from, { sid }, goto)) {
      goto(pages.account.url);
    }
  }
  async function onConfirm() {
    await deleteForm({ id: fid });
    if (!sid) {
      goto(pages.dashboard.url);
      return;
    }
    if (!handleRedirect(params.from, { sid }, goto)) {
      goto(pages.sites.overview.url, sid);
    }
  }
</script>

<Confirm
  open
  title="Delete {formName}?"
  {desc}
  cancelText="Cancel"
  confirmText="Delete"
  on:cancel={onCancel}
  on:confirm={onConfirm}
/>
